<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Automação - Habilitar conta</v-toolbar-title>
      </v-toolbar>
      <v-row class="px-4">
        <v-col md="4">
          <p class="font-weight-bold">Dados pra conta</p>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Id do participante"
                v-model="participantId"
                type="text"
                @input="getParticipantData()"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Banco"
                v-model="bankName"
                type="text"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Agência"
                v-model="bankAgency"
                type="text"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Conta"
                v-model="bankAccount"
                type="text"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Tipo de conta"
                v-model="bankType"
                :items="['Corrente', 'Poupança']"
                outlined dense hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          <p class="font-weight-bold pt-6">Atualização da turma</p>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Id da conta"
                v-model="gatewayId"
                type="text"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Multa"
                v-model.number="fines"
                type="number"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Juros"
                v-model.number="interest"
                type="number"
                outlined dense hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Processamento do Boleto/PIX"
                v-model="processingModeBankSlip"
                :items="['increment', 'decrement']"
                outlined dense hide-details="auto"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Processamento do Cartão"
                v-model="processingModeCreditCard"
                :items="['increment', 'decrement']"
                outlined dense hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="8">
          <p class="font-weight-bold">Postman</p>
          <v-textarea
            rows="8"
            :value="postmanData"
            outlined dense hide-details="auto"
          ></v-textarea>
          <p class="font-weight-bold pt-6">Mysql</p>
          <v-textarea
            rows="5"
            :value="mySqlData"
            outlined dense hide-details="auto"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      loading: false,
      participantId: '',
      participantData: {},
      customerData: {},
      bankName: 'Não informado',
      bankAgency: '0000',
      bankAccount: '00000000-0',
      bankType: 'Corrente',
      gatewayId: '',
      fines: 3,
      interest: 1,
      processingModeBankSlip: 'increment',
      processingModeCreditCard: 'increment'
    }
  },
  computed: {
    celebrationId () {
      return this.participantData && this.participantData.celebration && this.participantData.celebration.id
    },
    celebrationName () {
      return this.participantData && this.participantData.celebration && this.participantData.celebration.name
    },
    customer () {
      return (this.participantData && this.participantData.customer) || {}
    },
    customerAddress () {
      return (this.customerData && this.customerData.address) || {}
    },
    postmanData () {
      return `{
  "name": "${this.celebrationName}",
  "owner": {
    "name": "${this.customer.name}",
    "document": "${this.customer.person_document}",
    "phone_number": "${this.customer.phone_number}",
    "email": "${this.customer.email}",
    "address": {
      "street": "${this.customerAddress.street}",
      "number": "${this.customerAddress.number}",
      "neighborhood": "${this.customerAddress.neighborhood}",
      "city": "${this.customerAddress.city}",
      "state": "${this.customerAddress.state}",
      "zip_code": "${this.customerAddress.postal_code}",
      "complement": "${this.customerAddress.complement}"
    },
    "bank_data": {
      "name": "${this.bankName}",
      "agency": "${this.bankAgency}",
      "account_number": "${this.bankAccount}",
      "type": "${this.bankType}"
    }
  }
}`
    },
    mySqlData () {
      return `UPDATE fundraising_app_prod.celebrations SET gateway_id = '${this.gatewayId}', fine_for_delay = ${this.fines.toFixed(1)}, daily_interest = ${this.interest.toFixed(1)}, processing_mode_bank_slip = '${this.processingModeBankSlip}', processing_mode_pix = '${this.processingModeBankSlip}', processing_mode_credit_card = '${this.processingModeCreditCard}' WHERE id = '${this.celebrationId}';
UPDATE fundraising_app_prod.participants SET role = 'financial' WHERE id = '${this.participantId}';`
    }
  },
  watch: {
    participantId (value) {
      axios.get('participants/' + value)
        .then(response => {
          if (response.data) this.participantData = { ...response.data }
          if (response.data && response.data.customer && response.data.customer.id) {
            axios.get('customers/' + response.data.customer.id)
              .then(customer => {
                this.loading = false
                if (customer.data) this.customerData = { ...customer.data }
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            this.loading = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
